class ProductInfo extends HTMLElement {

  cartUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;

  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.cache = {};
  }

  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.onVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }

  onVariantChange({ data: { target, type, selectedOptionValues } }) {
    this.classList.remove('js-first-load');
    const productUrl = target.dataset.productUrl || this.dataset.url;
    
    // Store the focused element to restore focus after DOM update
    const focusedElement = document.activeElement;
    const isRadioButton = focusedElement && focusedElement.type === 'radio';
    const radioButtonId = isRadioButton ? focusedElement.id : null;

    this.render(type, productUrl, this.buildRequestUrlWithParams(productUrl, selectedOptionValues), radioButtonId);
  }

  async fetch(requestUrl) {
    if (this.cache[requestUrl]) {
      return this.cache[requestUrl];
    }

    const response = await fetch(requestUrl);
    const responseText = await response.text();

    this.cache[requestUrl] = responseText;
    return responseText;
  }

  async render(type, productUrl, requestUrl, focusedRadioId = null) {
    const responseText = await this.fetch(requestUrl);

    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const variant = ProductUtils.getSelectedVariant(html.querySelector('product-info'));

    this.updateURL(productUrl, variant?.id);
    this.pickupAvailability?.update(variant);

    ProductUtils.updateVariantInputs(this.querySelector('[data-form-container]'), variant?.id, {
      callback: (input) => input.dispatchEvent(new Event('change', { bubbles: true }))
    });

    const sections = [
      '[data-buy-buttons]',
      `#price-${this.sectionId}`,
      '[data-sku]',
      `[data-variant-options]`,
      "[data-title]",
      '[data-selected-value-label]',
    ];

    const outerSections = [];

    if (type == 'color') {
      sections.push('[data-badges]');
      outerSections.push('media-gallery')
    }

    for (let section of sections) {
      ProductUtils.updateSource(this, html, section, true);
    }

    /***[ALS]: this logic prevents media gallery from breaking down after color change */
    for (let section of outerSections) {
      const sourceElement = html.querySelector(section);
      if (sourceElement) {
        const targetElement = document.querySelector(section);
        if (targetElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      }
    }

    window.reinitPhotoSwipe();

    // Restore focus to the radio button after DOM update to prevent focus loss
    if (focusedRadioId) {
      // Use requestAnimationFrame to ensure DOM updates are complete
      requestAnimationFrame(() => {
        const radioButton = document.getElementById(focusedRadioId);
        if (radioButton) {
          radioButton.focus();
        }
      });
    }

  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = [];
    params.push(`section_id=${this.sectionId}`)

    if (optionValues.length)
      params.push(`option_values=${optionValues.join(',')}`);

    return `${url}?${params.join('&')}`;
  }

  updateURL(url, variantId) {
    this.querySelector('share-button')?.updateUrl(
      `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
    );

    if (this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
  }


}

if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}
